/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RasterDto } from '../../models/raster-dto';

export interface CreateRaster$Params {
      body: RasterDto
}

export function createRaster(http: HttpClient, rootUrl: string, params: CreateRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterDto>> {
  const rb = new RequestBuilder(rootUrl, createRaster.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RasterDto>;
    })
  );
}

createRaster.PATH = '/v1/raster';
